import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';

import GroupsList from 'groups/components/list';

class GroupsRowContainer extends Component {
  render = () => (
    <GroupsList.Row
      handleToggle={this.props.handleToggle}
      company={this.props.company}
      subcompany={this.props.subcompany}
      group={this.props.group}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
});

export default connect(mapStateToProps, null)(GroupsRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/containers/GroupsRowContainer.js